import React from "react";
import styled from "@emotion/styled";

import { InRowSaveToButton } from "components/opportunities/saving/InRowSaveToButton";
import { EllipsisTooltipTextLink } from "lib/core_components/EllipsisTooltip";
import { OpportunityEntityType } from "lib/types/graphQLEnums";

export function SupplierNameCell({
  supplierGuid,
  supplierName,
}: {
  supplierGuid: string;
  supplierName: string;
}) {
  const SaveButton = () => (
    <InRowSaveToButton
      entityType={"supplier"}
      entityIds={[supplierGuid]}
      entityName={supplierName}
      displayType={"button"}
      // suppliers cannot be saved to "lists" and so will never show as "saved"
      // need to revisit "isSaved" and "listCount" as part of APP-2157

      defaultOpportunityValues={{
        name: supplierName,
        assignedToId: window.currentUser?.guid,
        entities: [
          {
            entityId: supplierGuid,
            entityType: OpportunityEntityType.Organisation,
          },
        ],
      }}
    />
  );

  return (
    <NameColumn>
      <EllipsisTooltipTextLink
        fullText={supplierName}
        linkText={supplierName}
        linkProps={{
          to: `/suppliers/${supplierGuid}`,
        }}
      />
      <SaveButton />
    </NameColumn>
  );
}

const NameColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  line-height: 32px;
`;
